'use client';

import { useGlobalContext } from '@/store/contexts/global-context';

export const GlobalContextDebug = () => {
    const globalContext = useGlobalContext();

    const handleLogToConsole = () => {
        console.log('[GlobalContext]', globalContext);
    };

    const json = JSON.stringify(globalContext, null, 2);

    return (
        <section className="debug-section">
            <h3>Global context</h3>
            <div className="debug-controls">
                <button type="button" className="debug-global-context-log-btn" onClick={handleLogToConsole}>
                    Log to console
                </button>
            </div>
            <pre className="debug-global-context-json" data-testid="debug-global-context-json">
                {json}
            </pre>
        </section>
    );
};
